import ExpandButton from 'components/molecules/expand-button';
import { Link } from 'react-router-dom';
import { Routes } from 'router/routes';
import { useTranslation } from 'react-i18next';
import { languagesMap } from 'constants/languages';
import classNames from 'classnames';
import useUser from 'utils/useUser';
import ExclamationTriangleIcon from 'components/atoms/icons/exclamation-triangle';

import s from './styles.module.scss';

import type { Languages } from 'infrastructure/enums';
import type { FC } from 'react';

interface PatientCellProps {
  guid: string;
  name: string;
  dob: string;
  expand: boolean;
  language: Languages;
  provider: string;
  pmpmStatus?: boolean | null;
  interactionStatus?: boolean;
  onExpand: () => void;
}

const PatientCell: FC<PatientCellProps> = ({
  guid,
  name,
  provider,
  dob,
  language,
  expand,
  pmpmStatus,
  interactionStatus,
  onExpand,
}) => {
  const { isCriticalOrAtRiskAlertingRole, isAgencyDoctor } = useUser();
  const { t } = useTranslation();
  const showCROBadge = pmpmStatus && isAgencyDoctor && false; // false - to hide this flag

  return (
    <div className={s.wrapper}>
      <ExpandButton expanded={expand} onClick={onExpand} />
      <div className={s['patient-info-wrapper']}>
        <div className={s.patient}>
          <p
            className={classNames(s.name, {
              [s.disabled]: isCriticalOrAtRiskAlertingRole,
            })}
          >
            <Link to={Routes.patientGuid(guid)}>{name}</Link>
          </p>
          <div>
            <p className={s.date}>{dob}</p>
            <p className={s.language}>{languagesMap[language]}</p>
          </div>
          <p
            className={classNames(
              s['two-way-sync'],
              interactionStatus && s.sync,
            )}
          >
            {t('labels.2waySync')} -{' '}
            {interactionStatus ? t('labels.yes') : t('labels.no')}
          </p>
          {showCROBadge && (
            <p className={s.cro}>
              {t('labels.cro')}
              <ExclamationTriangleIcon />
            </p>
          )}
        </div>
        <div className={s.provider}>
          {t('labels.provider')}: <span>{provider}</span>
        </div>
      </div>
    </div>
  );
};
export default PatientCell;
